var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center justify-content-center bg-primary text-white rounded-circle text-uppercase",class:_vm.classObject},[(_vm.url)?_c('img',{staticClass:"rounded-circle h-100 w-100",attrs:{"src":_vm.url,"alt":""}}):_c('span',[_vm._v(_vm._s(this.initials))])])
}
var staticRenderFns = []

export { render, staticRenderFns }